module.exports = __webpack_public_path__ + "static/tatianawork6-80a5f5a34dbaeceee136caa6c4fd0a7b.jpeg";